import Plyr from 'plyr'

export default {
    init() {
        if ($('[data-modal-init]').length) {
            const modalRoot = this

            $('[data-modal-init]').each(function () {
                const anchor = this.getAttribute('data-modal-init')
                const modal = $(`[data-modal*='${anchor}']`)
                const background01 = $(modal).find('.modal__bg01')
                const background02 = $(modal).find('.modal__bg02')
                const close = $(modal).find('[data-close-btn]')

                const typeVideo = $(modal).find('[data-video-container]')

                let content = $(modal).find('[data-video-container]')
                let player
                let vid

                if (typeVideo.length) {
                    content = $(modal).find('[data-video-container]')
                    player = $(modal).find('[data-video-player]')

                    /* :: Video Player Init
                    ---------------------------------- */
                    vid = new Plyr(player)
                } else {
                    content = $(modal).find('[data-modal-container]')
                }

                let modalLoaded = 'false'

                /* :: Toggle Modal
                ---------------------------------- */
                $(this)
                    .find('[data-modal-trigger]')
                    .click(e => {
                        e.preventDefault()
                        modalLoaded = 'false'
                        const openModal = new TimelineMax()

                        $('body').css('overflow', 'hidden')
                        $(modal).addClass('modal--open')

                        // :---- Animate In Modal
                        openModal
                            .set(background01, { x: '-108%' })
                            .set(background02, { x: '-108%' })
                            .set(content, { y: '8%' })
                            .set(background01, { opacity: 1 })
                            .set(background02, { opacity: 1 })
                            .to(background01, 0.48, {
                                x: '-8%',
                                ease: Circ.easeInOut,
                            })
                            .to(background02, 0.48, {
                                x: '-8%',
                                delay: -0.32,
                                ease: Circ.easeInOut,
                            })
                            .to(content, 0.64, {
                                y: '0%',
                                opacity: 1,
                                ease: Power2.easeOut,
                                onComplete: () => {
                                    if (typeVideo.length) {
                                        vid.play()
                                    }
                                    modalLoaded = 'true'
                                    modalRoot.closeModal(
                                        modal,
                                        vid,
                                        typeVideo,
                                        content,
                                        modalLoaded,
                                        close,
                                        background01,
                                        background02,
                                    )
                                },
                            })
                            .to(close, 0.32, {
                                opacity: 1,
                                delay: -0.32,
                                ease: Power2.easeOut,
                            })
                    })
            })
        }

        this.closeButton()
    },

    /* :: Close Modal
    ---------------------------------- */
    closeModal(modal, vid, typeVideo, content, modalLoaded, close, background01, background02) {
        if (modalLoaded === 'true') {
            $(close).click(e => {
                modalLoaded = 'false'

                if (typeVideo.length) {
                    vid.pause()
                }

                const clearModal = new TimelineMax()

                // :---- Animate Out Modal
                clearModal
                    .to(close, 0.32, {
                        opacity: 0,
                        ease: Power2.easeOut,
                    })
                    .to(content, 0.64, {
                        y: '8%',
                        opacity: 0,
                        delay: -0.32,
                        ease: Power2.easeOut,
                    })
                    .to(background02, 0.64, {
                        x: '108%',
                        delay: -0.48,
                        ease: Circ.easeInOut,
                    })
                    .to(background01, 0.72, {
                        x: '108%',
                        delay: -0.56,
                        ease: Circ.easeInOut,
                        onComplete: () => {
                            $('body').css('overflow', 'auto')
                            $(modal).removeClass('modal--open')
                        },
                    })
            })
        }
    },

    closeButton() {
        $('[data-close-btn]').bind('webkitAnimationEnd mozAnimationEnd animationEnd', function () {
            $(this).removeClass('close--animate')
        })

        $('[data-close-btn]').mouseenter(function () {
            $(this).addClass('close--animate')
        })
    },
}
